module.exports = __webpack_public_path__ + "media/the-factory-bloc.f56ca322.mp3";